import gql from "graphql-tag";

export default gql`
	mutation updateClient($id: ID, $update: Update, $parentId: ID) {
		client(id: $id, update: $update, parentId: $parentId)
	}
`;
